import './Markers.css';

export function TachoWorkSvgData(width: number, height: number, fillColor: string) {
  return `
   <svg class="idata-target-marker" width="${width}" height="${height}" viewBox="-2 -2 28 28" fill="${fillColor}" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 8.34727V13.6907L18.0471 9.6831L14.1353 13.6489L20.7236 20.3283L18.0883 23L11.5 16.3207L4.91175 23L2.27645 20.3283L8.86467 13.6489L4.95292 9.6831L1 13.6907V8.34727L8.24709 1L10.8823 3.67173L7.58822 7.01137L11.5 10.9772L15.4118 7.01137L12.1177 3.67173L14.753 1L22 8.34727Z"/>
    <path d="M22 8.34727V13.6907L18.0471 9.6831L14.1353 13.6489L20.7236 20.3283L18.0883 23L11.5 16.3207L4.91175 23L2.27645 20.3283L8.86467 13.6489L4.95292 9.6831L1 13.6907V8.34727L8.24709 1L10.8823 3.67173L7.58822 7.01137L11.5 10.9772L15.4118 7.01137L12.1177 3.67173L14.753 1L22 8.34727Z"/>
   </svg>`;
}
